module.exports = __webpack_public_path__ + "static/media/logo192.d7e88681.png";